import { useCallback, useEffect, useRef } from 'react'
import cn from 'classnames'
import { useForm, Controller } from 'react-hook-form'

import { useToggle } from '../../../hooks'
import { LAB_ORDER_ATTRIBUTES } from '../../../lib/const'
import ErrorMessage from '../../common/ErrorMessage'
import { useCheckout } from '../useCheckout'

const MAX_NOTE_LENGHT = 200

const Boutique = () => {
  const { order, updateOrder } = useCheckout()
  const [showBoutique, toggleShowBoutique] = useToggle(order?.data?.attributes?.boutiqueShipping)
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors, isSubmitting },
  } = useForm()
  const watchBoutiqueShippingNote = watch('boutiqueShippingNote')
  const allowSaveNote =
    watchBoutiqueShippingNote &&
    watchBoutiqueShippingNote !== order?.data?.attributes?.boutiqueShippingNote

  const handleUpdateBoutique = useCallback(
    ({ boutiqueShippingNote }) =>
      updateOrder({
        type: LAB_ORDER_ATTRIBUTES.boutiqueShipping,
        value: true,
        boutiqueShippingNote,
      }),
    [order],
  )

  // PATCH on every user-driven toggle: on-check enables boutique while keeping
  // any previously saved note, off-check disables and clears the note. The
  // first run is skipped so a fresh page load with boutique disabled does not
  // re-emit the same false state to the server.
  const didMount = useRef(false)
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true
      return
    }
    updateOrder({
      type: LAB_ORDER_ATTRIBUTES.boutiqueShipping,
      value: showBoutique,
      boutiqueShippingNote: showBoutique
        ? order?.data?.attributes?.boutiqueShippingNote ?? ''
        : '',
    })
  }, [showBoutique])

  return (
    <div data-ix="fade-up-1" className="accordion js-accordion margin-top">
      <div className="accordion__item js-accordion-item">
        <div className="accordion-header js-accordion-header" style={{ height: '40px', paddingLeft: '0px', marginLeft: '0px' }}>
          <div className="accordion-item no-padding" style={{ paddingLeft: '0px', marginLeft: '0px' }}>
            <div className="form-block-11 w-form" style={{ paddingLeft: '0px', marginLeft: '0px' }}>
              <div id="email-form-3" name="email-form-3">
                <div style={{ paddingLeft: '0px', marginLeft: '0px' }}>
                  <label
                    id="check"
                    className="w-checkbox checkbox-field-4"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      lineHeight: '1',
                      marginLeft: '0px',
                      paddingLeft: '0px',
                    }}
                  >
                    <div
                      className={cn(
                        'w-checkbox-input w-checkbox-input--inputType-custom check secondary',
                        { 'w--redirected-checked': showBoutique }
                      )}
                      style={{
                        width: '18px',
                        height: '18px',
                        minWidth: '18px',
                        minHeight: '18px',
                        margin: 0,
                        display: 'inline-block',
                        verticalAlign: 'middle',
                      }}
                    />
                    <input
                      type="checkbox"
                      onChange={toggleShowBoutique}
                      style={{ opacity: 0, position: 'absolute', zIndex: '-1' }}
                    />
                    <span
                      htmlFor="check1"
                      id="check-label"
                      className="w-form-label"
                      style={{
                        fontSize: '14px',
                        verticalAlign: 'middle',
                        display: 'inline-block',
                        paddingTop: '3px',
                      }}
                    >
                      Add Boutique Packaging
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showBoutique && (
          <form
            className="accordion-body js-accordion-body"
            onSubmit={handleSubmit(handleUpdateBoutique)}
          >
            <div id="show-boutique" className="accordion-item-content">
              <div className="form-block-input margin-top w-form">
                <div className="form-input select-field area">
                  <div className="select-field-wrapper area">
                    <Controller
                      rules={{
                        required: true,
                        maxLength: {
                          value: MAX_NOTE_LENGHT,
                          message: `Max lengh is ${MAX_NOTE_LENGHT}.`,
                        },
                      }}
                      name="boutiqueShippingNote"
                      control={control}
                      defaultValue={order?.data?.attributes?.boutiqueShippingNote}
                      render={({ field }) => (
                        <textarea
                          {...field}
                          placeholder="Write a note for your client..."
                          maxLength={MAX_NOTE_LENGHT}
                          className="text-field-2 font-size-14 area w-input"
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
              <button
                type="submit"
                style={{marginTop: '10px'}}
                className={cn('button w-inline-block', {
                  disabled: isSubmitting || !allowSaveNote,
                })}
                disabled={isSubmitting || !allowSaveNote}
              >
                {isSubmitting ? (
                  <div>{order?.data?.attributes?.boutiqueShippingNote ? "Updating...": "Saving..."}</div>
                ) : (
                  <div>{order?.data?.attributes?.boutiqueShippingNote ? "Update Boutique Note": "Save Boutique Note"}</div>
                )}
              </button>
              {errors?.boutiqueShippingNote?.message && (
                <ErrorMessage errors={errors?.boutiqueShippingNote?.message} />
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  )
}

export default Boutique
